module.exports = __webpack_public_path__ + "static/media/Sharp-Product-8K-Reflective-IGZO-Displays.b3eb642a.jpg";